$(document).ready(function () {
    var $form = $("#rating-photography"),
        $rcp = $form.find("#product-rcp"),
        $rce = $form.find("#product-rce"),
        $material = $form.find("#product-material"),
        $results = $form.find("#results");

    function updatePrice($checkbox)  {
        var price = 0;

        if ($rcp.is($checkbox)) {
            $rce.removeAttr('checked');
        } else if ($rce.is($checkbox)) {
            $rcp.removeAttr('checked');
        }

        if ($rcp.is(':checked')) {
            price = 170;
        }

        if ($rce.is(':checked')) {
            price = 199;
        }

        if ($material.is(':checked')) {
            price += 300;
        }

        if (price === 0) {
            $results.html("Sélectionnez une garantie afin d'avoir une estimation du prix de votre assurance photographe professionnel !");
        } else {
            $results.html("À partir de<br><b>"+ Math.round(price/12*100)/100 +" &euro;/mois</b><br>soit <b style=\"font-size: 100%\">"+ price +" &euro;/an</b>");
        }
    }

    $form.find(':checkbox, :radio').on('change', function () {
        updatePrice($(this));
    });

    if ($form.length > 0) {
        updatePrice();
    }
});
